module.exports = __webpack_public_path__ + "static/media/currency-exchange.1f2d24c3.svg";